<template>
  <div class="row mt-2">
    <div class="col-xl-8 col-lg-7 col-sm-12">
      <div class="video-detail" v-if="video">
        <div class="iframe-container">
          <iframe
            width="100%"
            height="400"
            :src="'https://www.youtube.com/embed/'+video.snippet.resourceId.videoId+'?autoplay=1'"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
        <h3 class="typo-h4 mt-2">{{video.snippet.title}}</h3>
        <div class="typo-small mt-2 description" v-html="htmlize(video.snippet.description)">
          <br />
        </div>
      </div>
    </div>
    <PerfectScrollbar class="col-xl-4 col-lg-5 col-sm-12 mt-lg-0 mt-3 playlist">
      <VideoItem
        :class="{ 'mt-3': ind >= 1, 'active': item.id == video.id }"
        :item="item"
        direction="horizontal"
        v-for="(item, ind) in playlist"
        :key="ind"
        @watch="onWatch"
      />
    </PerfectScrollbar>
  </div>
</template>

<script>
import { VideoItem } from "../../components";
import { linkifyAll as linkify } from "@/plugins/linkify";
export default {
  name: "TopicWatchVideo",
  components: {
    VideoItem
  },
  filters: {},
  props: {
    topic: Object,
    playlist: Array,
    video: Object
  },
  methods: {
    onWatch(item) {
      this.$emit("watch", item);
    },
    htmlize(content) {
      let contentFormat = content;
      while (contentFormat.indexOf("\n") > -1)
        contentFormat = contentFormat.replace("\n", "<br>");

      return linkify(contentFormat);
    }
  }
};
</script>

<style lang="scss" scoped>


.video-detail {
  display: flex;
  flex-direction: column;
  flex: 1;

  .iframe-container {
    border-radius: 5px;
    display: flex;
    flex: 1;
    overflow: hidden;
  }
  
  .description {
    ::v-deep a {
      color: $cPrimary;
    }
  }
}


.playlist {
  max-height: calc(100vh - 200px);
  // overflow: overlay;
}
</style>
